/**
 * Central configuration for all cron campaigns
 * Used by Admin UI to create email templates
 */

export const CRON_TYPES = [
  {
    value: "send_orgs_registered_no_listing_email",
    label: "Org Registered No Listing",
  },
  {
    value: "send_orgs_previous_free_no_active_email",
    label: "Org Previous Free No Active",
  },
  {
    value: "send_orgs_previous_paid_no_active_email",
    label: "Org Previous Paid No Active",
  },
  {
    value: "send_orgs_active_free_upgrade_email",
    label: "Org Active Free Upgrade",
  },
  {
    value: "send_orgs_active_paid_email",
    label: "Org Active Paid",
  },
  {
    value: "send_weekly_artist_broadcast",
    label: "Weekly Artist Broadcast",
  },
];